import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const HUB_TAB_PARAM = 'tab';

// The selected Hub tab lives in the dashboard URL, so browser Back from a
// workout lands on the tab the learner left, not the first one. A tag that is
// not one of the active tabs (yet, or any more) falls back to the first.
export const useHubTab = (activeTags: string[], fallbackTag = 'Action') => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tagFromUrl = searchParams.get(HUB_TAB_PARAM);

  const tag =
    tagFromUrl && activeTags.includes(tagFromUrl)
      ? tagFromUrl
      : activeTags[0] || fallbackTag;

  const setTag = useCallback(
    (nextTag: string) => {
      setSearchParams(
        (params) => {
          const next = new URLSearchParams(params);
          next.set(HUB_TAB_PARAM, nextTag);
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return [tag, setTag] as const;
};
